import { jsxs as l, Fragment as e, jsx as C } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(e, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.9954 10.6146C8.17553 9.81669 8.88442 9.25 9.70244 9.25H13H16.4073C17.0739 9.25 17.6826 9.62868 17.9772 10.2266L19.4666 13.25H20C20.9665 13.25 21.75 14.0335 21.75 15V19C21.75 19.4142 21.4142 19.75 21 19.75H19.9877C19.8622 21.0133 18.7963 22 17.5 22C16.2037 22 15.1378 21.0133 15.0123 19.75H12.9877C12.8622 21.0133 11.7963 22 10.5 22C9.20366 22 8.13777 21.0133 8.01234 19.75H6C5.58579 19.75 5.25 19.4142 5.25 19V15C5.25 14.0335 6.0335 13.25 7 13.25H7.40045L7.9954 10.6146ZM12.25 10.75H9.70244C9.58558 10.75 9.48431 10.831 9.45857 10.9449L8.9382 13.25H12.2927C12.265 13.1718 12.25 13.0877 12.25 13V10.75ZM13.7073 13.25C13.735 13.1718 13.75 13.0877 13.75 13V10.75H16.4073C16.5026 10.75 16.5895 10.8041 16.6316 10.8895L17.7945 13.25H13.7073ZM10.5 20.5C11.0523 20.5 11.5 20.0523 11.5 19.5C11.5 18.9477 11.0523 18.5 10.5 18.5C9.94772 18.5 9.5 18.9477 9.5 19.5C9.5 20.0523 9.94772 20.5 10.5 20.5ZM18.5 19.5C18.5 20.0523 18.0523 20.5 17.5 20.5C16.9477 20.5 16.5 20.0523 16.5 19.5C16.5 18.9477 16.9477 18.5 17.5 18.5C18.0523 18.5 18.5 18.9477 18.5 19.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7048 2.17171C12.4516 1.75554 13.3624 1.63231 14.2454 1.90475C15.9606 2.43389 16.9221 4.25325 16.3929 5.96841C15.8638 7.68357 14.0444 8.64502 12.3293 8.11588C11.8866 7.97932 11.4932 7.75609 11.1628 7.47055C10.8882 7.51228 10.6042 7.51274 10.3201 7.46739C9.7551 7.93964 8.9696 8.12591 8.21221 7.89225C7.0248 7.52592 6.35917 6.26636 6.7255 5.07894C6.95915 4.3216 7.55554 3.77758 8.26397 3.57686C8.83792 2.35723 10.2366 1.71449 11.5617 2.12331C11.6101 2.13822 11.6578 2.15437 11.7048 2.17171Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.25 9.5C3.25 8.25736 4.25736 7.25 5.5 7.25C6.74264 7.25 7.75 8.25736 7.75 9.5C7.75 10.7426 6.74264 11.75 5.5 11.75C4.25736 11.75 3.25 10.7426 3.25 9.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M5 14C5 14.5523 4.55228 15 4 15C3.44772 15 3 14.5523 3 14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as default
};
